import { render } from "./NavigationMenu.vue?vue&type=template&id=5b1a3a20&scoped=true"
import script from "./NavigationMenu.vue?vue&type=script&lang=js"
export * from "./NavigationMenu.vue?vue&type=script&lang=js"

import "./NavigationMenu.vue?vue&type=style&index=0&id=5b1a3a20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b1a3a20"]])

export default __exports__